import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Form.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import useFormInput from '../hooks/useFormInput';
import formValidationRulesPropType from '../propTypes/formValidationRulesPropType';
import EmailRecipientsInput from './EmailRecipientsInput';
var FormEmailRecipientsInput = function (_a) {
    var initialValue = _a.initialValue, label = _a.label, name = _a.name, rules = _a.rules, props = __rest(_a, ["initialValue", "label", "name", "rules"]);
    var _b = useFormInput({
        initialValue: initialValue,
        name: name,
        label: label,
        rules: rules,
        shouldValidateOnChange: true
    }), errorMessage = _b.errorMessage, formattedLabel = _b.formattedLabel, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
    return (React.createElement(EmailRecipientsInput, __assign({}, props, { errorMessage: errorMessage, label: formattedLabel, onBlur: onBlur, onChange: onChange, value: value })));
};
FormEmailRecipientsInput.propTypes = {
    initialValue: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.node,
    name: PropTypes.string.isRequired,
    rules: formValidationRulesPropType
};
export default FormEmailRecipientsInput;
//# sourceMappingURL=Form.EmailRecipientsInput.js.map